import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/pages/typescript';
import theme from '@styles/theme';
export default {
  container: (bg: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    width: '100%',
    bg,
    display: 'flex',
    flexDirection: 'column',
    mt: MARGINS_BLOCKS[marginTop],
    mb: MARGINS_BLOCKS[marginBottom]
  }),
  image: {
    width: '100%',
    position: 'relative',
    height: ['68.533333333vw', '68.533333333vw', '70.3125vw', '70.3125vw', '23.958333333vw']
  },
  textContainer: {
    maxWidth: '753px',
    m: ['24px 24px', '24px 24px', '24px 40px 32px 40px', '24px 40px 32px 40px', '40px']
  },
  descriptionText: (color: string) => ({
    color,
    fontSize: [theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.smallText, theme.fontSizes.text],
    lineHeight: '140%',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    '> * ': {
      mb: '24px'
    }
  })
};